import { render, staticRenderFns } from "./ProductsSection.vue?vue&type=template&id=23fc6ba4&scoped=true"
import script from "./ProductsSection.vue?vue&type=script&lang=js"
export * from "./ProductsSection.vue?vue&type=script&lang=js"
import style0 from "./ProductsSection.vue?vue&type=style&index=0&id=23fc6ba4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23fc6ba4",
  null
  
)

export default component.exports